var map = {
	"./Dell_Technologies_logo-full-color.svg": "28e7",
	"./dell-tech-logo-grey.svg": "5cbf",
	"./dt-logo-lockup-hz-wht-aug2017.png": "af4e",
	"./dt-logo-wht-no-subs.png": "08cb",
	"./logo-intel-white.png": "1e3a",
	"./vmware-logo-grey.svg": "c568",
	"./vmware-logo2.png": "03ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07bb";